import React, { useEffect, useState } from "react";
import { Button, Form, Segment } from "semantic-ui-react";
import { useDispatch, useSelector, connect } from "react-redux";
import { initialize, Field, reduxForm, formValueSelector } from "redux-form";
import { getAdvertisers, updateUser } from "../firebase";
import { openModal, closeModal } from "../actions";
import {
  TextInput,
  CheckboxInput,
  SelectInput,
} from "../templates/utils/form-fields";

let UserForm = ({
  userRecord,
  handleSubmit,
  pristine,
  invalid,
  submitting,
  error,
  selectedRetailer,
  advertiserRestricted,
  retailerRestricted,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const retailers = useSelector((state) => state.retailers);
  const advertisers = useSelector((state) => state.advertisers);
  const [retailerOptions, setRetailerOptions] = useState([]);
  const [advertiserOptions, setAdvertiserOptions] = useState([]);

  //const getAdvertiserId = async (adv) => {
  //  let id;
  //  await advertisers.forEach((item) => {
  //    if (item.displayName === adv) id = item.advertiserId;
  //  });
  //  return id;
  //};

  const getAdvertiserId = (advertiser) => {
    return advertisers.find((item) => {
      return item.displayName === advertiser;
    });
  };

  useEffect(() => {
    dispatch(initialize("userForm", { ...userRecord }));
  }, [userRecord, dispatch]);

  useEffect(() => {
    const array = retailers.map((retailer) => {
      return { text: retailer.name, key: retailer.name, value: retailer.name };
    });
    setRetailerOptions(array);
  }, [retailers]);

  useEffect(() => {
    if (selectedRetailer) {
      getAdvertisers(selectedRetailer, user, dispatch);
    }
  }, [selectedRetailer, user, dispatch]);

  useEffect(() => {
    const array = advertisers.map((advertiser) => {
      return {
        text: advertiser.displayName,
        key: advertiser.id,
        value: advertiser.displayName,
      };
    });
    setAdvertiserOptions(array);
  }, [advertisers]);

  const handleSubmitForm = (values) => {
    if (values.restrictByAdvertiser) {
      //values.advertiserId = await getAdvertiserId(values.advertiser);
      const advertiserArray = values.advertiser.map((ad) => {
        const adv = getAdvertiserId(ad);
        return adv;
      });
      values.advertisers = advertiserArray;
    }
    dispatch(
      openModal("ProgressModal", {
        title: values.displayName,
        name: `Updating ${values.displayName}`,
        progress: 50,
      })
    );
    updateUser(userRecord.id, values)
      .then(() => {
        dispatch(
          openModal("ProgressModal", {
            title: values.displayName,
            name: `Updating ${values.displayName}`,
            progress: 100,
          })
        );
        window.setTimeout(() => {
          dispatch(closeModal());
        }, 1500);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Segment>
      <Form onSubmit={handleSubmit(handleSubmitForm)}>
        <Field
          label="Display name"
          name="displayName"
          value={userRecord.displayName}
          component={TextInput}
          type="text"
        />
        <Field
          label="Organisation"
          name="organisation"
          value={userRecord.organisation}
          type="text"
          component={TextInput}
        />
        <Field
          label="isAdOps"
          name="isAdOps"
          value={userRecord.isAdOps}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="isAdmin"
          name="isAdmin"
          value={userRecord.isAdmin}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="isViewer"
          name="isViewer"
          value={userRecord.isViewer}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="isEditor"
          name="isEditor"
          value={userRecord.isEditor}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="restrictByRetailer"
          name="restrictByRetailer"
          value={userRecord.restrictByRetailer}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="Retailer"
          name="retailer"
          value={userRecord.retailer}
          options={retailerOptions}
          component={SelectInput}
          placeholder="Choose a retailer"
          disabled={!retailerRestricted}
        />
        <Field
          label="restrictByAdvertiser"
          name="restrictByAdvertiser"
          value={userRecord.restrictByAdvertiser}
          component={CheckboxInput}
          type="checkbox"
        />
        <Field
          label="Advertiser"
          name="advertiser"
          value={userRecord.advertiser}
          options={advertiserOptions}
          component={SelectInput}
          placeholder="Choose an advertiser"
          disabled={!advertiserRestricted}
          multiple
        />
        <Button
          type="submit"
          positive
          size="tiny"
          disabled={submitting || pristine || invalid}
        >
          Submit
        </Button>
      </Form>
    </Segment>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.displayName) {
    errors.displayName = "Please enter a display name (first name / last name)";
  }
  if (!values.organisation) {
    errors.organisation = "Please enter an organisation";
  }
  if (values.restrictByRetailer) {
    if (!values.retailer) {
      errors.retailer = "Please choose a retailer";
    }
  }
  if (values.restrictByAdvertiser) {
    if (!values.advertiser) {
      errors.retailer = "Please choose an advertiser";
    }
  }

  return errors;
};

UserForm = reduxForm({
  validate,
  form: "userForm",
})(UserForm);

const selector = formValueSelector("userForm");
UserForm = connect((state) => {
  const selectedRetailer = selector(state, "retailer");
  const retailerRestricted = selector(state, "restrictByRetailer");
  const advertiserRestricted = selector(state, "restrictByAdvertiser");
  return {
    selectedRetailer,
    retailerRestricted,
    advertiserRestricted,
  };
})(UserForm);

export default UserForm;
